import { Table, Tbody, Thead } from "@chakra-ui/react";
import { formatNumberDisplay } from "../../utils/displayGetters";
import { returnRoundedNumber } from ".";
import { BreakdownTypeEnum } from "../../graphqlExternal/generated";


export interface dataTableProps {
  data: any[];
  columns: string[];
  breakdownType?: BreakdownTypeEnum;
}

export interface CategoryImpressionsTableProps {
  dataTableProps: dataTableProps;
}

export const CategoryImpressionsTable = ({
  dataTableProps: { data, columns }
}: CategoryImpressionsTableProps) => {

  return (
    <Table
      ml={4}
      mt={30}
      mb={70}
      width="95%"
      borderRadius="12px"
      borderCollapse="separate"
    >
      <Thead
        backgroundColor="#C2E0E2"
        textAlign="center"
        fontSize="16px"
        mt={4}
      >
        <tr>
          {columns.map((column) => (
            <th key={column} style={{ height: "50px" }}>
              {column}
            </th>
          ))}
        </tr>
      </Thead>
      <Tbody
        textAlign="center"
        mt={20}
        borderWidth={"2px"}
        backgroundColor={"white"}
      >
        {data.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {Object.keys(row).map((key, index) => {
              if (key !== "startDate" && key !== "endDate") {
                if (
                  key === "impressionShare" ||
                  key === "brandUnsafeRate" ||
                  key === "unsafeImpressionShare"
                ) {
                  return (
                    <td
                      key={index}
                      style={{
                        padding: "10px 0",
                        fontSize: "16px",
                        border: "1px solid #E2E8F0",
                      }}
                    >
                      {returnRoundedNumber(
                        row[key]
                      )+ "%"}
                    </td>
                  );
                } else if (
                  key === "totalImpressions" ||
                  key === "totalUnsafeImpressions"
                ) {
                  return (
                    <td
                      key={index}
                      style={{
                        padding: "10px 0",
                        fontSize: "16px",
                        border: "1px solid #E2E8F0",
                      }}
                    >
                      {formatNumberDisplay(row[key])}
                    </td>
                  );
                } else {
                  return (
                    <td
                      key={index}
                      style={{
                        padding: "10px 0",
                        fontSize: "16px",
                        border: "1px solid #E2E8F0",
                      }}
                    >
                      {row[key]}
                    </td>
                  );
                }
              }
              return null;
            })}
          </tr>
        ))}
      </Tbody>
    </Table>
  );
};

export const formatImpressionShare = (impressionShare: number, dp: number) => {
  return `${(impressionShare * 100).toFixed(dp)}%`;
};




